import { loadingSpinnerActions } from "./actions/loadingSpinnerActions";
import { switchTenantActions } from "./actions/switchTenantActions";
var appReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
            onShowSwitchTenantButton: function () { return dispatch({ type: switchTenantActions.SHOW_SWITCH_TENANT_BUTTON }); },
            onHideSwitchTenantButton: function () { return dispatch({ type: switchTenantActions.HIDE_SWITCH_TENANT_BUTTON }); }
        };
    }
};
export default appReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/AppReduxProps.ts
// module id = 204
// module chunks = 0